<template>
  <div class="newsCenter">
    <Menu></Menu>
    <div id="newsCenter" style="margin-top: 80px;">
		<div class="four-feature-first-screen">
			<div class="postion-screen">
				<img src="../assets/img/news.jpg" alt="" class="pcStyle"/>
				<img src="../assets/img/newsMb.jpg" alt="" class="mbStyle"/>
				<div class="four-feature-first-screen-box">
					<div>新闻中心</div>
					<div>News Center</div> 
				</div>
			</div>
		</div>
		<div class="newsCenter-second-screen">
			<div class="newsCenter-second-screen-box">
				<div>
					<div>
						<img src="../assets/img/nwes1.jpg" alt="" />
					</div>
					<div>
						黑龙江省委书记、省长王文涛<br/>
						到社区参加生活垃圾分类志愿者服务活动
					</div>
				</div>
				<div>
					<div>
						<img src="../assets/img/nwes2.jpg" alt="" />
					</div>
					<div>
						黑龙江省委书记、省人大常委会主任张庆伟<br/>
						参加节能宣传周生活垃圾分类活动
					</div>
				</div>
				<div>
					<div>
						<img src="../assets/img/nwes3.jpg" alt="" />
					</div>
					<div>
						黑龙江省委常委、副省长王永康<br/>
						到社区参加生活垃圾分类志愿者服务活动
					</div>
				</div>
				<div>
					<div>
						<img src="../assets/img/nwes4.jpg" alt="" />
					</div>
					<div>
						黑龙江省政府副省长聂云凌<br/>
						调研松北区生活垃圾分类示范社区
					</div>
				</div>
				<div>
					<div>
						<img src="../assets/img/nwes5.jpg" alt="" />
					</div>
					<div>
						哈尔滨市委书记，市长孙喆<br/>
						视察党政机关单位生活垃圾分类工作
					</div>
				</div>
				<div>
					<div>
						<img src="../assets/img/nwes6.jpg" alt="" />
					</div>
					<div>
						市政府研究室考察<br/>
						哈尔滨循环经济产业园区
					</div>
				</div>
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'newsCenter',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/newsCenter.scss';

</style>


// WEBPACK FOOTER //
// src/components/newsCenter.vue